module.exports = __webpack_public_path__ + "static/media/quote.d67d50f0.svg";